import { render } from "./LanguageFlagSelectBox.vue?vue&type=template&id=46375fc0"
import script from "./LanguageFlagSelectBox.vue?vue&type=script&lang=js"
export * from "./LanguageFlagSelectBox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__